export const trialTitle = `Ready to Transform Your Infrastructure? Let's Discuss Your Project`;

export const trialDescription = `
We offer flexible engagement models for businesses of all sizes. Whether you need 
cloud migration, CI/CD setup, Kubernetes deployment, or ongoing DevOps support, 
we're here to help. Contact us for a free consultation and project estimate.
`;
